import { getPiezoClient } from './PiezoClient';
import { PiezoDebugPrefix } from './PiezoClient.constants';
import type { PiezoInitResult } from './PiezoClient.types';
import { getPiezoWorkerPool } from '../pool/workerPool';

/**
 * Re-provisions the operator's Piezo material, bypassing the cache, then rebuilds the worker pool.
 *
 * The pool must be rebuilt: a worker reads the cache once at startup, so old workers would keep signing
 * with the replaced material. terminate() first, because warmUp is memoised.
 *
 * Never throws; the pool rebuild is best-effort.
 */
export async function refreshPiezoMaterial(region: string): Promise<PiezoInitResult> {
  const result = await getPiezoClient().init({ region, loadFromCache: false });
  if (result.error) {
    // Pool left alone: its workers still hold the material signing is currently using.
    console.warn(`${PiezoDebugPrefix} material refresh failed: ${result.error.message}`);
    return result;
  }

  const pool = getPiezoWorkerPool();
  pool.terminate();
  // Already resolved: init above wrote the cache these workers read.
  await pool.warmUp(Promise.resolve(), region, 0).catch(() => undefined);
  return result;
}
